export default __webpack_public_path__ + "img/logo.8fd37d5a.png";